export default __webpack_public_path__ + "static/media/Shri_Mahakaleshwar_Temple_Ujjain_-_panoramio_4.806d62f0.jpg";